import { Controller } from "@hotwired/stimulus"

// Shows the target only when the radio carrying data-reveal-when-value
// matches the checked radio's value. Used by subscriptions/new to hide the
// Stripe card element when a saved payment method is selected.
export default class extends Controller {
  static targets = ["panel"]
  static values = { when: String }

  connect() {
    this.update()
  }

  update() {
    const checked = this.element.querySelector('input[type=radio]:checked')
    // No radio group rendered (e.g. no saved payment methods) => always show
    const show = !checked || checked.value === this.whenValue
    this.panelTargets.forEach(p => p.classList.toggle('hidden', !show))
  }
}
